// Copyright (C) AirWorks Solutions, Inc - All Rights Reserved
// DO NOT REDISTRIBUTE
// UNAUTHORIZED COPYING OF THIS FILE, ANY PART OR WHOLE, VIA ANY MEDIUM IS STRICTLY PROHIBITED
// PROPRIETARY AND CONFIDENTIAL

import { awSignUpPalette } from 'Utils/themes';
import { AUTH_TWO_COLUMN_MIN_WIDTH_PX } from '../styles';

// Width of the pricing-card column beside the form (Figma "Tablet & Desktop — 768px+" board)
const PRICING_CARD_COLUMN_WIDTH_PX = 300;
// The card (~430px tall) plus its sticky offset and some breathing room: shorter viewports, such as
// landscape phones, could never show the bottom of a pinned card
const STICKY_CARD_MIN_VIEWPORT_HEIGHT_PX = 520;

const styles = (theme: any) => ({
  // Form above the pricing card on phones; side by side from the two-column breakpoint
  layout: {
    display: 'flex',
    flexDirection: 'column',
    gap: theme.spacing(3),
    [theme.breakpoints.up(AUTH_TWO_COLUMN_MIN_WIDTH_PX)]: {
      flexDirection: 'row',
      alignItems: 'flex-start',
      gap: theme.spacing(5),
    },
  },
  formColumn: {
    display: 'flex',
    flexDirection: 'column',
    gap: theme.spacing(3),
    flex: 1,
    minWidth: 0,
  },
  // The card stays in view while the form scrolls, but only where the viewport can show all of it;
  // on shorter screens it scrolls with the page
  cardColumn: {
    [theme.breakpoints.up(AUTH_TWO_COLUMN_MIN_WIDTH_PX)]: {
      flex: `0 0 ${PRICING_CARD_COLUMN_WIDTH_PX}px`,
    },
    [`${theme.breakpoints.up(AUTH_TWO_COLUMN_MIN_WIDTH_PX)} and (min-height: ${STICKY_CARD_MIN_VIEWPORT_HEIGHT_PX}px)`]: {
      position: 'sticky',
      top: theme.spacing(4),
    },
  },
  details: {
    color: '#FFFFFF',
  },
  header: {
    marginTop: theme.spacing(4),
  },
  form: {
    marginTop: theme.spacing(2),
  },
  // Server-side failures, styled as the spec's error-summary banner
  errorBanner: {
    display: 'flex',
    alignItems: 'center',
    gap: theme.spacing(1.25),
    padding: theme.spacing(1.5, 2),
    borderRadius: theme.spacing(1),
    background: awSignUpPalette.errorBannerBackground,
    border: `1px solid ${awSignUpPalette.errorBannerBorder}`,
    color: awSignUpPalette.errorBannerText,
  },
  errorBannerText: {
    color: 'inherit',
  },
  buttonWrapper: {
    marginTop: theme.spacing(4),
    position: 'relative',
    display: 'grid',
    gridTemplateColumns: 'auto auto',
  },
  button: {
    paddingTop: theme.spacing(2),
    paddingBottom: theme.spacing(2),
    paddingLeft: theme.spacing(10),
    paddingRight: theme.spacing(10),
    height: '50px',
  },
  buttonProgress: {
    position: 'absolute',
    top: '50%',
    left: '50%',
    marginTop: -12,
    marginLeft: -12,
  },
  loginPrompt: {
    textAlign: 'center',
    color: awSignUpPalette.bodyText,
  },
  loginLink: {
    color: awSignUpPalette.link,
  },
  formRow: {
    display: 'grid',
    gridTemplateColumns: '1fr 1fr',
    gridGap: theme.spacing(2),
  },
  dropdown: {
    paddingTop: theme.spacing(1),
    boxShadow: '0 2px 4px 0 rgba(0,0,0,0.1)',
    border: '1px solid #4f5a64',
    height: '56px',
    borderRadius: '4px',
  },
  innerDropdownText: {
    display: 'contents',
    color: '#ffffff',
  },
  menuItem: {
    justifyContent: 'space-between',
  },
  signupForm: {
    display: 'none',
  },
  agreeTerms: {
    marginLeft: theme.spacing(3),
    color: '#FFFFFF',
  },
  formControl: {
    margin: theme.spacing(1),
    minWidth: 120,
    display: 'contents',
    marginLeft: '0px',
  },
});

export default styles;
